(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');
    module.controller('DaySchemeTimeConfirmationModalController', [        
        'date', 
        '$uibModalInstance',
        'modalData',
        DaySchemeTimeConfirmationModalController]
    );
    
    function DaySchemeTimeConfirmationModalController(date, $uibModalInstance, modalData) {
    
        var vm = this;
        vm.date = date;

        vm.dateFormatted = moment(vm.date).format('dddd LL');
        vm.timeFormatted = moment(vm.date).format('LT');

        vm.blockTime = modalData.blockTime;
        vm.deleteTime = modalData.deleteTime;

        vm.no = function () {
            $uibModalInstance.dismiss();
        };

        vm.yes = function () {
            $uibModalInstance.close();
        };
    }
})();
